// eslint-disable-next-line no-useless-escape
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const dateRegex = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)(19[0-8][0-9]|199[0-9]|20[0-9]{2}|2100)/

const SEXOS = [
  { value: 'M', text: 'Masculino' },
  { value: 'F', text: 'Feminino' }
]

const ESTADOS_CIVIS = [
  { value: 'solteiro', text: 'Solteiro' },
  { value: 'casado', text: 'Casado' },
  { value: 'separado', text: 'Separado' },
  { value: 'divorciado', text: 'Divorciado' },
  { value: 'viuvo', text: 'Viúvo' }
]

const TIPOS_EXAME = [
  { value: 1, text: 'Admissional', slug: 'admissional' },
  { value: 2, text: 'Demissional', slug: 'demissional' },
  { value: 3, text: 'Periódico', slug: 'periodico' },
  { value: 4, text: 'Mudança de Função', slug: 'mudanca-de-funcao' },
  { value: 5, text: 'Retorno ao Trabalho', slug: 'retorno-ao-trabalho' }
]

const ESTADOS = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO'
]

export { dateRegex, emailRegex, SEXOS, TIPOS_EXAME, ESTADOS, ESTADOS_CIVIS }
